<template>
  <div>
    <v-row>
      <v-col>
        <v-card
          class="d-flex flex-wrap justify-space-between"
        >
          <v-card
            class="pa-3"
            flat
          >
            <tw-agendamento-cadastro
              @update="onUpdate"
            >
              <template v-slot:activator="{ on }">
                <v-btn color="primary" class="mr-2" v-on="on">
                  <v-icon>mdi-plus</v-icon>
                  Novo Agendamento
                </v-btn>
              </template>
            </tw-agendamento-cadastro>
          </v-card>
        </v-card>
      </v-col>
    </v-row>
    <div v-if="loading">
      <tw-overlay-circular-loading/>
    </div>
    <v-row class="fill-height">
      <v-col>
        <v-sheet>
          <v-toolbar
            flat
          >
            <v-btn
              outlined
              class="mr-2"
              color="grey darken-2"
              @click="setToday"
            >
              Hoje
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="prev"
            >
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn
              fab
              text
              small
              color="grey darken-2"
              @click="next"
            >
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu
              bottom
              right
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="grey darken-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Dia</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Semana</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Mês</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 dias</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-sheet>
        <v-sheet>
          <v-calendar
            ref="calendar"
            v-model="value"
            color="primary"
            :events="events"
            :event-color="getEventColor"
            :type="type"
            :first-time="intervals.first"
            :interval-minutes="intervals.minutes"
            :interval-count="intervals.count"
            :interval-height="intervals.height"
            :interval-style="internalStyle"
            @click:event="showEvent"
            @click:more="viewDay"
            @click:date="viewDay"
            @change="updateRange"
          >
            <template #day-body="{ date, week, present }">
              <div
                v-if="present"
                class="v-current-time first"
                :style="{ top: nowY }"
              ></div>
            </template>
          </v-calendar>
          <tw-calendario-detalhes
            v-model="selectedOpen"
            :agendamento="selectedEvent"
            :element="selectedElement"
            @update="onUpdate"
          />
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AgendamentoCadastro from '@/modules/agendamento/cadastro/AgendamentoCadastro.vue';
import EmpresaService from '@/api/empresas-service';
import CalendarioDetalhes from '@/modules/calendario/CalendarioDetalhes.vue';
import CalendarioService from '@/api/calendario-service';
import calendarioMixin from './calendario-mixin';

const intervalsDefault = {
  first: '00:00',
  minutes: 60,
  count: 24,
  height: 48,
};
export default {
  mixins: [calendarioMixin],
  data: () => ({
    intervals: intervalsDefault,
    empresa: {},
    ready: false,
    loading: false,
    value: '',
    type: 'day',
    typeToLabel: {
      month: 'Mês',
      week: 'Semana',
      day: 'Dia',
      '4day': '4 dias',
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    cancelamentos: [],
    agendamentos: [],
  }),
  mounted() {
    EmpresaService.getContext()
      .then((data) => {
        this.empresa = data.data;
        this.intervals.first = this.empresa.inicioAtendimento;
        this.intervals.count = this.getIntervalCount(this.empresa);
      })
      .finally(() => {
        this.ready = true;
        this.updateTime();
        this.$refs.calendar.checkChange();
      });
  },
  methods: {
    onUpdate() {
      this.selectedOpen = false;
      this.update(this.$refs.calendar.lastStart.date, this.$refs.calendar.lastEnd.date);
    },
    internalStyle(interval) {
      if (this.loading || !this.ready) {
        return {
          backgroundColor: 'rgba(0,0,0,0.05)',
        };
      }
      const inactive = this.checkInactive(this.empresa, interval);
      const startOfHour = interval.minute === 0;
      const mid = 'rgba(0,0,0,0.1)';
      return {
        backgroundColor: inactive ? 'rgba(0,0,0,0.05)' : undefined,
        borderTop: startOfHour ? undefined : `1px dashed ${mid}`,
      };
    },
    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000);
    },
    viewDay({ date }) {
      this.value = date;
      this.type = 'day';
    },
    setToday() {
      this.value = '';
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({
      nativeEvent,
      event,
    }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }
      nativeEvent.stopPropagation();
    },
    updateRange({
      start,
      end,
    }) {
      this.update(start.date, end.date);
    },
    loadAgendamentos(start, end) {
      return CalendarioService.findAgendamentos({
        dataInicio: start,
        dataFim: end,
      })
        .then((data) => this.flat(data.data))
        .then((data) => {
          this.agendamentos = data;
        });
    },
    loadCancelamento(start, end) {
      return CalendarioService.findCancelamentos({
        dataInicio: start,
        dataFim: end,
      })
        .then((data) => {
          this.cancelamentos = data.data;
        });
    },
    update(start, end) {
      this.loading = true;
      this.events = [];
      return Promise.all([
        this.loadAgendamentos(start, end),
        this.loadCancelamento(start, end),
      ])
        .then(() => {
          this.montar(start, end);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    flat(agendamentos) {
      const data = [];
      agendamentos.forEach((agenda) => {
        agenda.itens.forEach((item) => {
          const flat = {
            ...item,
            ...agenda,
          };
          delete flat.itens;
          data.push(flat);
        });
      });
      return data;
    },
    findCancelamento(agenda) {
      return this.cancelamentos.find((c) => c.cliente.id === agenda.cliente.id
        && c.agendamento.id === agenda.id
        && c.data === agenda.dia
        && c.horaInicio === agenda.horaInicio
        && c.horaFim === agenda.horaFim);
    },
    montar(start, end) {
      let inicio = this.$moment(start);
      const fim = this.$moment(end);
      while (inicio.isSameOrBefore(fim)) {
        this.getValids(inicio, this.agendamentos)
          .forEach((agenda) => {
            const cancelamento = this.findCancelamento(agenda);
            this.events.push({
              agenda,
              cancelamento,
              name: cancelamento ? `${agenda.cliente.nome} (Cancelado)` : agenda.cliente.nome,
              start: agenda.inicio,
              end: agenda.fim,
              details: `<div><B>${agenda.horaInicio}</B> - <B>${agenda.horaFim}</B></div>`,
              color: agenda.cliente.cor,
              timed: true,
            });
          });
        inicio = inicio.add(1, 'day');
      }
    },
    getValids(date, agendamentosFlat) {
      const dayWeek = date.format('dddd')
        .toUpperCase();
      const temp = [];
      agendamentosFlat.forEach((agenda) => {
        if (
          this.$moment(agenda.dataInicio)
            .isSameOrBefore(date)
          && this.$moment(agenda.dataFim)
            .isSameOrAfter(date)
          && agenda.diaSemana === dayWeek
        ) {
          const dateFormatted = date.format('yyyy-MM-DD');
          const dia = {
            ...agenda,
            dia: dateFormatted,
            inicio: new Date(`${dateFormatted}T${agenda.horaInicio}`),
            fim: new Date(`${dateFormatted}T${agenda.horaFim}`),
          };
          temp.push(dia);
        }
      });
      return temp;
    },
  },
  computed: {
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
    nowY() {
      if (this.cal) {
        const timeToY = this.cal.timeToY(this.cal.times.now);
        return timeToY ? `${timeToY}px` : '-10px';
      }
      return '-10px';
    },
  },
  components: {
    TwCalendarioDetalhes: CalendarioDetalhes,
    twAgendamentoCadastro: AgendamentoCadastro,
  },
};
</script>
<style lang="scss">
.v-calendar-daily__scroll-area {
  overflow-y: auto !important;
}

.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: '';
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}
</style>
